import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    message: { type: String, default: "Are you sure you want to remove %{name}?" },
    defaultName: { type: String, default: "this attendee" }
  }

  confirm(event) {
    const clientName = this.element.dataset.clientName || this.defaultNameValue
    const message = this.messageValue.replace("%{name}", clientName)
    if (!window.confirm(message)) {
      event.preventDefault();
    }
  }
}
